package diana.soleil.design.iraniancanadienbazzar.feature.orders

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/** Koin bindings for commerce. Aggregated by the app composition root (`:shared`). */
val ordersModule = module {
    viewModel { (businessId: String, productId: String) -> ProductDetailViewModel(get(), get(), get(), businessId, productId) }
    viewModel { CartViewModel(get()) }
    viewModel { CheckoutViewModel(get(), get(), get()) }
    viewModel { OrderHistoryViewModel(get()) }
    viewModel { (orderId: String) -> OrderConfirmationViewModel(get(), orderId) }
    viewModel { (businessId: String) -> ManageProductsViewModel(get(), businessId) }
    viewModel { (businessId: String) -> ManageOrdersViewModel(get(), businessId) }
}
